import { render, staticRenderFns } from "./UiEmbedVideo.vue?vue&type=template&id=0e390628"
import script from "./UiEmbedVideo.vue?vue&type=script&lang=js"
export * from "./UiEmbedVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports